import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Image from 'next/future/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCircleCheck, faAward } from '@fortawesome/pro-regular-svg-icons';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons';
import { Card, Button, Progress } from '@platzi/ui';
import { imageLoader } from 'src/utils/imageOptimizer';
import styles from './RoutesCard.module.sass';

export const RoutesCard = (props) => {
  const { t } = useTranslation();
  const isLogged = useSelector((state) => state.get('header').get('isLogged')) || false;
  const color = useSelector((state) => state.get('school').get('color_dark')) || '';
  const [school, setShool] = useState('');
  const percentageCompleted = props.progress?.percentage;

  useEffect(() => {
    const queryString = window.location.pathname.replaceAll('/', '_');
    setShool(queryString);
  }, []);

  const renderFooter = () => {
    if (percentageCompleted === 0 || isLogged === false) {
      return (
        <Button
          customClass={styles.RoutesCardButton}
          as="a"
          href={`${props.url}?school=${school}`}
          color="sky"
          hierarchy="secondary"
        >
          {t('escuela.routesCard.btn')}
        </Button>
      );
    }

    if (percentageCompleted === 100) {
      return (
        <>
          <Progress customClass={styles.RoutesCardProgressBar} percentageReached={props.progress?.percentage} />
          <p>
            <FontAwesomeIcon className={styles.RouteCompleted} icon={faCircleCheck} />{' '}
            {t('escuela.routesCard.completed')}
          </p>
        </>
      );
    }

    if (percentageCompleted < 100) {
      return (
        <>
          <Progress customClass={styles.RoutesCardProgressBar} percentageReached={props.progress?.percentage} />
          <p>
            <FontAwesomeIcon className={styles.RouteInProgress} icon={faAward} />
            <span
              dangerouslySetInnerHTML={{
                __html: t('escuela.routesCard.inProgress', { count: props.progress?.approvedCoursesCount }),
              }}
            />
          </p>
        </>
      );
    }
  };

  return (
    <Card isDark customClass={styles.RoutesCard}>
      <a href={`${props?.url}?school=${school}`} className={styles.RoutesCardLink}>
        <div className={styles.RoutesCardContent}>
          <div className={styles.RoutesCardProfesional}>
            <span style={{ color: color }}>{t('escuela.routesCard.label')}</span>
            {props?.isProfessional && <FontAwesomeIcon icon={faBadgeCheck} />}
          </div>
          <h3>{props?.title}</h3>
          <p>{props?.description}</p>
        </div>
        <div>
          <div className={styles.RoutesCardData}>
            <div className={styles.RoutesCardCourses}>
              <div>
                <FontAwesomeIcon icon={faPlus} />
              </div>
              {props?.courses?.map((item, index: number) => (
                <Image
                  key={`courseImage-${index}`}
                  loader={imageLoader}
                  src={item?.image}
                  alt={item?.title}
                  width={24}
                  height={24}
                />
              ))}
            </div>
            <span>
              <b>{props?.totalOfCourses}</b> {t('escuela.routesCard.courses')}
            </span>
            <div className={styles.RoutesCardDivisor}>•</div>
            <span>
              <b>{props?.duration}</b> {t('escuela.routesCard.hours')}
            </span>
          </div>
          <div className={styles.RoutesCardFooter}>{renderFooter()}</div>
        </div>
      </a>
    </Card>
  );
};
